import { Outlet } from "react-router";
import { useSafePendingUrl } from "@/router/hooks/useSavePendingUrl";

export const RouterUtility = () => {
  useSafePendingUrl();
  return <Outlet />;
};
